import React, { useState } from 'react';
import HttpServices from 'src/services/httpService';
import { integrateModuleURL } from 'src/services/urlService';
import { useEffect } from 'react';
import LoadFacebookSdk from '../loadFacebookSdk';
import { useToaster } from 'src/utils/toaster/toasterContext';
import CustomDomainRedirectIframe from '../customDomainIframe';
import { CommonHelper } from 'src/utils/commonHelper';
import ThreadsAuthorizationModal from '../threads-integration/threads-authorization-modal';

import { Config } from 'src/config';

const ThreadsReAuthenticate = ({ AccountId, handleClose ,getConnectedNetworks}) => {
   const [isAuthorizationModalOpen, setAuthorizationModal] = useState(true);
  const { showToast } = useToaster();
  const isCustomDomain = CommonHelper.CustomDomain();
  let isProcessing = false;
  let intervalId = null;

  useEffect(() => {
    intervalId = setInterval(() => {
      checkAccessTokenReceivedFromthread();
    }, Config.Common.socialAccountsIntegrationInterval);
    return () => {
      clearInterval(intervalId);
    };
  }, [])

const getThreadsOauthToken = () => {
    let redirectUri = encodeURIComponent(Config.Threads.redirectUri);
    window.open(
      `${Config.Threads.authorizeUrl}?client_id=${Config.Threads.clientId}&redirect_uri=${redirectUri}&scope=${Config.Threads.scope}&response_type=code`,
      '_blank'
    );
  };

  const checkAccessTokenReceivedFromthread = () => {
    if (isCustomDomain) {
      const handleMessage = (event) => {
        const { type, code } = event.data;
        if (type === "threads_auth_code" && code && !isProcessing) {
          isProcessing = true;
          window.removeEventListener("message", handleMessage, false); // Remove event listener
          clearInterval(intervalId); // Stop polling
          sendAccessTokenToServer(code); // Process the code
        }
      };

      window.addEventListener("message", handleMessage, false);
    } else {
      var token = localStorage.getItem("threads_auth_code");
      var error = localStorage.getItem("threads_error");
      if (token) {
        localStorage.removeItem("threads_auth_code");
        clearInterval(intervalId);
        sendAccessTokenToServer(token);
      }
      else if (error) {
        localStorage.removeItem("threads_error");
        clearInterval(intervalId);
        showToast(error, 'e');
      }
    }
  };
  const threadSuccessCallback = (data, message) => {
    showToast(message, 's');
    getConnectedNetworks();
    handleClose();
  }
  const threadFailureCallback = (message) => {
    showToast(message, 'e');
    handleClose();
  }
  const sendAccessTokenToServer = (code) => {
    let threadForm = {
      code,
      account_id: AccountId
    };
    let postProps = {
      url: integrateModuleURL.reAuthenticateThreads,
      body: threadForm,
      successCallback: threadSuccessCallback,
      failureCallback: threadFailureCallback
    }
    HttpServices.Post(postProps);
  };


    return (
        <>
            {isAuthorizationModalOpen &&
                <ThreadsAuthorizationModal handleConnectThreads={getThreadsOauthToken} 
                    handleClose={handleClose}
                />}
            {isCustomDomain && <CustomDomainRedirectIframe serviceName="threads"/> }
        </>
    );
};
export default ThreadsReAuthenticate;
